import React from 'react';

import Page from '../../components/ui/Page';
import ResetPassword from '../../components/application/ResetPassword';
import Onboarding from '../../components/application/Authentication/Onboarding';

import * as Styles from './ResetPasswordStyles';

interface Props {
  readonly location: Location;
}

const ResetPasswordForm: React.FC<Props> = () => {
  return (
    <Page>
      <Styles.Container>
        <Styles.FormContainer>
          <ResetPassword />
        </Styles.FormContainer>
        <Onboarding />
      </Styles.Container>
    </Page>
  );
};

export default ResetPasswordForm;
